let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gm2nf")).then(() => parcelRequire('hjnLm'));